import React from "react";
import "./certificates.css";
import { FaCertificate } from "react-icons/fa";

function Certificates() {
  return (
    <section id="certificates">
      {/* <h5>What Skills I Have</h5> */}
      <h2>Certificates</h2>
      <div className="container certificates__container">
        <div className="certificates__frontend">
          <h3>Frontend Development</h3>
          <div className="certificates__content">
            <article className="certificates__details">
              <FaCertificate className="certificates__details-icon" />
              <h4>
                <a
                  href="https://coursera.org/share/cdc2d59aa04c493ef5ac5d6a28696812"
                  target="_blank"
                  rel="noreferrer"
                >
                  Front-End Web Development with React from (Hong Kong
                  university- cousera)
                </a>
              </h4>
            </article>
            <article className="certificates__details">
              <FaCertificate className="certificates__details-icon" />
              <h4>
                <a
                  href="https://coursera.org/share/99ed94e6c28ddee36c70b1fe2a105f0a"
                  target="_blank"
                  rel="noreferrer"
                >
                  Front-End Web UI Frameworks and Tools: Bootstrap 4 from (Hong
                  Kong university-cousera)
                </a>
              </h4>
            </article>
            <article className="certificates__details">
              <FaCertificate className="certificates__details-icon" />
              <h4>
                <a
                  href="https://www.coursera.org/account/accomplishments/verify/RXQWVR6D9LW2?utm_source=link&utm_medium=certificate&utm_content=cert_image&utm_campaign=sharing_cta&utm_product=course"
                  target="_blank"
                  rel="noreferrer"
                >
                  Front-End Web Development with React from (Hong Kong
                  university- cousera)
                </a>
              </h4>
            </article>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Certificates;
